import { useFormik } from 'formik'
import * as Yup from 'yup'
import Ajax from '../../../Ajax'
import { Alert } from '../../..'
import Field from '../../form/fields/Field'
import { Button } from '@mui/material'
import { store } from '../../../stores/Store'
import { SelectOption } from '../../form/fields/SelectField'


export default function WorkflowTemplateForm ({workflow = null}) {

    var accountUid = store.AppStore.sessionInfo.userAccount.uid
    var accountOptions: SelectOption[] = [
        // {value: null, label: "Global (Available to all accounts)"}
    ]
    store.NodeStore.accounts.filter(account => account.accountType === "customer").forEach(account => {
        accountOptions.push({value: account.uid, label: account.label})
    })

    var formik = useFormik({
    
        initialValues: {
            label: workflow?.label,
            description: workflow?.description,
            accountUid: workflow?.accountUid ? workflow?.accountUid : accountUid,
        },

        validationSchema: Yup.object({
            label: Yup.string().matches(/^[ ,.@!$%#';:?()[\]~_+=À-Ö\p{Sc}\p{So}\p{Mn}\p{P}\p{Z}À-ÿ\w\n]*$/u, "You have used some illegal characters").required("This field is required"),
            description: Yup.string().required()
        }),

        onSubmit: async (values) => {
            if (workflow) {
                await Ajax.Workflow.UpdateTemplate({...workflow, ...values}).then(async () => {
                    await store.AppStore.getWorkflows()
                    store.AlertStore.Close()
                }).catch(() => {
                    Alert({message: "Failed to update Workflow"})
                })
            } else {
                var uid = values.label?.toUpperCase().replace(" ", "_")
                

                await Ajax.Workflow.CreateTemplate({uid: uid, ...values}).then(async () => {
                    await store.AppStore.getWorkflows()
                    store.AlertStore.Close()
                }).catch(() => {
                    Alert({message: "Failed to create Workflow"})
                })
            }
        }
    })

    return (
        <form className="form" onSubmit={formik.handleSubmit}>
            <Field.Text 
                formik
                name="label"
                label="Name" 
                value={formik.values.label} 
                warning={formik.errors.label} 
                onChange={formik.handleChange} />

            <Field.Text 
                formik
                rows={3}
                name="description"
                label="Description" 
                value={formik.values.description} 
                warning={formik.errors.description} 
                onChange={formik.handleChange} />

            {store.AppStore.checkJwtRole("sysuser") ? (
                <Field.Select 
                    formik
                    name="accountUid"
                    label="Account" 
                    placeholder="Global (Available to all accounts)"
                    value={formik.values.accountUid} 
                    warning={formik.errors.accountUid} 
                    options={accountOptions}
                    onChange={formik.handleChange} />
            ) : null}

            <Button 
                className="btn btn-sm" 
                color="success" 
                variant="contained" 
                disabled={formik.isSubmitting}
                type="submit">
                Submit
            </Button>
        </form>
    )
}